import "../css/article.scss"
import { ReadMoreButton } from "../UI/Buttons";
import {useArticle} from "../sanity/useArticle"
import PT from "../sanity/PortableText"
import {urlFor} from "../sanity/imageUrl"
import { LoadingSpinner } from "../UI/LoadingSpinner"

export const ArticleAusbildung = () => {
    const {data, loading} = useArticle('ausbildung')
    const heroUrl = data?.heroImage ? urlFor(data.heroImage) : null

    if (loading) {
        return (
            <div className="d-flex center article-section-margin">
                <div className="article-container d-flex center">
                    <LoadingSpinner label="Lädt…" />
                </div>
            </div>
        )
    }

    return (
        <div className="d-flex center article-section-margin">

            <div className="article-container d-flex center">
                {/*<div className="article-header d-flex center">*/}
                {/*    <img src={Logo} alt="Logo" style={{height: "200px"}}/>*/}
                {/*</div>*/}
                {heroUrl ? (
                    <div className="article-header d-flex center">
                        <img src={heroUrl} alt="Logo" className="article-logo"/>
                    </div>
                ) : null}
                <div className="title-with-image-container">

                    <h2 className="title">
                        <span className="image-text">{data?.title || 'Ausbildung'} </span>
                    </h2>
                </div>

                <div className="article-content center">
                    {data?.excerpt ? (
                        <PT value={data.excerpt} />
                    ) : (
                    <p>
                        Die Biodanza-Schule Freiburg bietet eine theoretische, methodische und erlebnisorientierte Ausbildung, die durch langjährige Forschung perfektioniert wurde und qualifiziert zum/zur Biodanza Lehrer:in mit einem international durch die IBFed anerkannten Diplom. Gemäß den methodischen Grundlagen von Professor Rolando Toro und dem Einheitlichen Ausbildungsprogramm besteht das Ziel der Schule darin, eine qualitativ hochwertige Ausbildung anzubieten, die für die Ausübung des Berufs des Biodanza-Lehrers geeignet ist.
                    </p>
                    )}


                    <ReadMoreButton link={"/ausbildung"} />

                </div>



            </div>
        </div>
    );
};


